import React, { useState, useEffect } from 'react';
import SchedaProdottoPS from "./SchedaProdottoPS";
import SchedaProdotto from "./SchedaProdotto";
import { useAuth0 } from '@auth0/auth0-react';
import apiUrl from './Apiurl';
import stilePulsanti from './interfaccia/stilePulsanti';

function AreaConflittoCodiciPS({idPSesistente,idPSnuovo,prodDB,setIDPSdiverso}) {


    console.log("idPSesistente",idPSesistente)
    console.log("idPSnuovo",idPSnuovo)
    console.log("prodDB",prodDB)

    //FARE I DUE GET DEI DUE CODICI PS + LE FUNZIONI PER ACCETTARE UNO O L'ALTRO
    
    const { user, getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState(""); 
    const [prodPSesistente, setProdPSesistente] = useState("");
    const [prodPSnuovo, setProdPSnuovo] = useState("");

    //funzione che associa idps a codicevs

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/prodotti/get/getProdottoPS/"+idPSesistente, {headers: {Authorization: "Bearer "+token}}) 
          .then(resp => resp.json())
          .then(data => setProdPSesistente(data)) 
      }, [ token,idPSesistente ]);

      useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/prodotti/get/getProdottoPS/"+idPSnuovo, {headers: {Authorization: "Bearer "+token}}) 
          .then(resp => resp.json())
          .then(data => setProdPSnuovo(data)) 
      }, [ token,idPSnuovo ]);


     useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);

      const accettaCodicePS = function(idFortunato) {
        if (!token) {
          console.warn("sto aspettando un token")
          return;
      }
      fetch(apiUrl + "/prodotti/patch/datoDoc/"+prodDB._id+"/codicePS/"+idFortunato, {headers: {Authorization: "Bearer "+token}}) 
        .then(resp => resp.json())
        .then(data => setIDPSdiverso({
          idPSdiversoTrovato: "",
          idAttuale: ""
        }))         
      }

      const esci = function() {
        setIDPSdiverso({
          idPSdiversoTrovato: "",
          idAttuale: ""
        })         
      }
    
   return (
            <div className="codiciPSconfronto flex w-100 pa3">
                <div className="w-30">
                    <h2>DA PS - old</h2>
                    <p>Il codice PS memorizzato in db su PS</p>
                    <button className={stilePulsanti.buttonClassesWhite} onClick={(idPSesistente) => accettaCodicePS(idPSesistente)}>Scelgo questo!</button>
                    <SchedaProdottoPS prod={prodPSesistente} />
                </div>
                <div className="w-30">
                    <h2>DA PS - new</h2>
                    <p>Questo codice PS su PS</p>
                    <button className={stilePulsanti.buttonClassesWhite} onClick={(idPSnuovo) => accettaCodicePS(idPSnuovo)}>Scelgo questo!</button>
                    <SchedaProdottoPS prod={prodPSnuovo} />
                </div>
                <div className="w-30">
                    <h2>DA DB</h2>
                    <p>Questo codice PS sul db</p>
                    <button className={stilePulsanti.buttonClassesWhite} onClick={esci}>Esci e non cambiare</button>
                    <SchedaProdotto prod={prodDB} />
                </div>
        
            </div>
            
        );

}

export default AreaConflittoCodiciPS;